module.exports = __webpack_public_path__ + "img/img-banner-news.837cc358.jpg";